//todo: modify metadisplay  block  when adding new
enum ShowCodeAndXML{
    ShowOutputRaw=0,
    ShowCodeBlocks=1,
    ShowCodeXml=2,
    ShowCodeJavascript=3,
    ShowOutputHtml=4,
    ShowOutputJson=5,
    ShowOutputNone=6,
    ShowCodeJson=7,
    ShowOutputTimings=8,
    
  }

export default ShowCodeAndXML;